import { CaptionRegularCR1 } from 'corgi/common/components/Typography';
import { getTraceID } from 'corgi/common/utils/newrelic';

const TraceId = () => {
  const traceID = typeof window !== 'undefined' && getTraceID();

  if (!traceID) {
    return null;
  }

  return (
    <CaptionRegularCR1 mt="sp_24" textAlign="center">
      {traceID}
    </CaptionRegularCR1>
  );
};

export default TraceId;
